export default __webpack_public_path__ + "static/media/login.39076f72.jpg";